export default __webpack_public_path__ + "static/open-graph-image-14271a8e9d12b56bbdd74c5f36e27b93.jpg";